<template>
	<div class="idi-table devices">
		<div class="idi-header">
			<div class="idi-cell">{{ $t('labels.general.imei') }}</div>
			<div class="idi-cell">{{ $t('labels.general.name') }}</div>
			<div class="idi-cell">{{ $t('labels.general.in_use') }}</div>
			<div class="idi-cell"></div>
		</div>
		<div v-for="group in groups.data" :key="group.id">
			<div class="group">
				<div>{{ group.name }}</div>
				<div class="btn-group">
					<button v-check-user:devices_edit_group="user_uid" class="btn btn-small btn-round" @click="editGroup(group.id)">{{ $t('buttons.general.edit') }}</button>
					<button v-check-user:devices_delete_group="user_uid" class="btn btn-small btn-round" @click="deleteGroup(group.id)">{{ $t('buttons.general.delete') }}</button>
				</div>
			</div>
			<div v-for="device in group.elements" :key="device.id" class="idi-row">
				<div class="idi-cell">
					<span>{{ device.uid }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ device.name }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ device.in_use }}</span>
				</div>
				<div class="idi-cell grid-area-operations align-right btn-group">
					<button class="btn btn-small btn-round" @click="editDevice(device.id)">{{ $t('buttons.general.edit') }}</button>
					<button class="btn btn-small btn-round" @click="deleteDevice(device.id)">{{ $t('buttons.general.delete') }}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'groups'
	],
	methods: {
		editGroup (group_id) {
			this.$root.$emit('editGroup', group_id)
		},
		editDevice (device_id) {
			this.$root.$emit('editDevice', device_id)
		},
		deleteGroup (group_id) {
			this.$emit('deleteGroup', group_id)
		},
		deleteDevice (device_id) {
			this.$emit('deleteDevice', device_id)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesDevicesList.vue